/**
 *
 * StepTwo
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {
  makeSelectClientDetails,
  makeSelectInsuranceOptions,
} from 'containers/Main/selectors';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  body: {
    padding: '12px 30px 0',
  },
  button: {
    ...theme.typography.button,
    color: '#fff',
    boxShadow: 'none',
    width: 139,
    height: 50,
    borderRadius: 2,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.8,
    },
  },
  backButton: {
    ...theme.typography.button,
    color: theme.palette.primary.main,
    height: 50,
    '&:hover': {
      opacity: 0.8,
    },
  },
  insuranceWrapper: {
    marginTop: 24,
    marginBottom: 40,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  insuranceImage: {
    border: '1px solid #E9ECED',
    borderRadius: 2,
    height: 100,
    width: 100,
    marginBottom: 8,
    padding: 12,
    objectFit: 'contain',
  },
  actionWrapper: {
    position: 'absolute',
    bottom: 24,
    left: 32,
    right: 32,
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

const StepTwo = ({ insurance, onBack, onClose }) => {
  const classes = useStyles();
  const clientDetails = useSelector(makeSelectClientDetails());
  const insuranceOptions = useSelector(makeSelectInsuranceOptions());
  const [siteCopy] = useSiteCopySelector(['insurance-modal']);

  const [data] = insuranceOptions.filter(item => item.value === insurance);

  const header = _get(siteCopy, 'pageCopy.page2.header', '');

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <Typography variant="h4" color="primary" align="center">
          {header}
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.body}>
        <Typography variant="body2" color="textPrimary" align="center">
          {_get(siteCopy, 'pageCopy.page2.description', '')}
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.insuranceWrapper}>
        <img
          src={_get(clientDetails, 'crediblemindLogo.url', '')}
          className={classes.insuranceImage}
          alt={data.label || data.value}
        />
        <Typography variant="overline" color="textPrimary" align="center">
          {data.label || data.value}
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.actionWrapper}>
        <ButtonBase className={classes.backButton} onClick={onBack}>
          <ChevronLeftIcon className={classes.icon} />
          {_get(siteCopy, 'pageCopy.page2.backButton', '')}
        </ButtonBase>
        <Button
          variant="contained"
          className={classes.button}
          onClick={onClose}
          color="primary"
        >
          {_get(siteCopy, 'pageCopy.page2.finishButton', '')}
        </Button>
      </Grid>
    </Grid>
  );
};

StepTwo.propTypes = {
  insurance: PropTypes.string,
  onBack: PropTypes.func,
  onClose: PropTypes.func,
};

export default StepTwo;
